// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryInformationListTsx from "./CanaryInformationList.tsx";

let make = CanaryInformationListTsx.InformationListLine;

let Line = {
  make: make
};

let make$1 = CanaryInformationListTsx.InformationListValueBadge;

let ValueBadge = {
  make: make$1
};

let make$2 = CanaryInformationListTsx.InformationListGap;

let Gap = {
  make: make$2
};

let make$3 = CanaryInformationListTsx.InformationList;

export {
  Line,
  ValueBadge,
  Gap,
  make$3 as make,
}
/* make Not a pure module */
